import { useEffect, useId, useRef, useState } from 'react';
import { api, type VisaDocumentKind } from './api';
import { VIZE_BELGELERI as M } from './metin/vize-belgeleri';

export function VisaDocumentPreview({ requestId, documentId, kind, resource, close }: { requestId: string; documentId: string; kind: VisaDocumentKind; resource: { url: string; mime: string }; close: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useId();
  const [failed, setFailed] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [downloadFailed, setDownloadFailed] = useState(false);
  useEffect(() => {
    const element = dialog.current;
    const trigger = document.activeElement as HTMLElement | null;
    element?.showModal();
    return () => { element?.close(); if (trigger?.isConnected) trigger.focus(); };
  }, []);
  const download = async () => {
    setDownloading(true); setDownloadFailed(false);
    try { await api.downloadVisaDocument(requestId, documentId); } catch { setDownloadFailed(true); } finally { setDownloading(false); }
  };
  return <dialog ref={dialog} className="visa-preview" aria-labelledby={title} data-testid="visa-document-preview" onCancel={event => { event.preventDefault(); close(); }}>
    <header><h2 id={title}>{M.onizleme}: {M.turler[kind]}</h2><button type="button" onClick={close} autoFocus>{M.onizlemeKapat}</button></header>
    <div className="visa-preview-content">
      {failed ? <div role="alert"><p>{M.onizlemeHatasi}</p></div> : null}
      {!failed && resource?.mime === 'application/pdf' ? <iframe data-testid="visa-preview-pdf" title={M.onizleme} src={resource.url} onError={() => setFailed(true)} /> : null}
      {!failed && resource && resource.mime !== 'application/pdf' ? <img data-testid="visa-preview-image" alt={M.turler[kind]} src={resource.url} onError={() => setFailed(true)} /> : null}
    </div>
    <footer>
      {resource?.mime === 'application/pdf' ? <p>{M.pdfIndir}</p> : null}
      <button type="button" disabled={downloading} onClick={() => void download()}>{downloading ? M.indiriliyor : M.indir}</button>
      {downloadFailed ? <p role="alert">{M.indirmeHatasi}</p> : null}
    </footer>
  </dialog>;
}
